import { TbArrowUpRight } from 'react-icons/tb'
import { Heading } from 'ui-kit/typography'
import { alternatives } from 'routes/Alternatives/alternatives'
import NavLink from 'ui-kit/actions/link/NavLink'
import classes from './DifferenceComparison.module.scss'

export const DifferenceComparisonCard = ({ id }: { id: string }) => {
  const alternative = alternatives.get(id)
  const integrationApp = alternatives.get('integration')

  if (!alternative) {
    return null
  }

  return (
    <li className={classes.item}>
      <div className={classes.content}>
        <Heading as={'h5'} size={'xs'} balance className={classes.caption}>
          <NavLink href={`alternatives/${id}`} className={classes.link}>
            {`${integrationApp && integrationApp.name} vs ${alternative.name}`}
          </NavLink>
        </Heading>
        <TbArrowUpRight className={classes.icon} />
      </div>
      <div className={classes.wrapper}>
        {integrationApp && (
          <img
            width={37}
            height={24}
            loading='lazy'
            src={integrationApp.logo.src}
            alt={integrationApp.name}
            className={classes.logo}
          />
        )}
        <img
          width={100}
          height={24}
          loading='lazy'
          src={alternative.logo.src}
          alt={alternative.name}
          className={classes.logo}
        />
      </div>
    </li>
  )
}
